import { jsx as i } from "react/jsx-runtime";
import { a as n, C as a } from "../../index-Bo5fc4VO.js";
import { MarketPopover as p } from "../MarketPopover/MarketPopover.js";
import { MarketTooltipContainer as m } from "./subcomponents/MarketTooltipContainer.js";
import { MarketPopoverTrigger as s } from "../MarketPopover/subcomponents/MarketPopoverTrigger.js";
import { MarketPopoverContent as C } from "../MarketPopover/subcomponents/MarketPopoverContent.js";
const r = (o) => {
  const {
    children: t,
    ...e
  } = o;
  return /* @__PURE__ */ i(
    p,
    {
      ...e,
      disableFocusManager: !0,
      container: m,
      interaction: { hover: !0, focus: !0 },
      viewportMargin: a,
      offset: n,
      role: "tooltip",
      children: t
    }
  );
};
r.Trigger = s;
r.Content = C;
export {
  r as MarketTooltip
};
